const landingpage = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Landing Page",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Landing Page",
            service: "pages",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              activeLimit: 8,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Label",
                    placeholder: "Enter Label",
                    required: true,
                    info: true,
                    character_count: 40,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  // "group": {
                  //     "type": 'footerGroupSelect',
                  //     "label": 'Group',
                  //     "placeholder": 'Select Group',
                  //     "load_url": '',
                  //     "required": false,
                  //     "info": false,
                  //     "character_count": 0,
                  //     "disabled": false,
                  //     "class": '',
                  //     "size": "12",
                  //     "style": ""
                  // },
                  // "subgroup": {
                  //     "type": 'subgroupSelect',
                  //     "label": 'Sub-Group',
                  //     "placeholder": 'Select Sub-Group',
                  //     "load_url": '',
                  //     "required": false,
                  //     "info": false,
                  //     "character_count": 0,
                  //     "disabled": false,
                  //     "class": '',
                  //     "size": "6",
                  //     "style": ""
                  // },
                },
                additionalProps: {
                  color: "#00a5ef",
                  icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/building.svg",
                  tool: "eConsult",
                  link_type: "External Link",
                  link_url: "",
                  // "subgroup": '',
                  // "locations": '',
                  // "qualifications": '',
                  // "availability": {
                  //     'locations':  []
                  // },
                  // "gender": {
                  //     'name':  'Male'
                  // },
                },
              },
            },
            children: [
              {
                type: "quickLinksTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Links",
                  // "type": "list",
                  type: "list",
                  // "variant": "filtered",
                  filter: "labels",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pr-3 pt-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    // "preview": {
                    //     "type": 'preview',
                    //     "label": 'Preview',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": "",
                    // },
                    title: {
                      type: "text",
                      label: "Name",
                      placeholder: "Enter Label",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "mr-2",
                      size: "6",
                      style: "",
                    },
                    no_of_items: {
                      type: "select",
                      label: "No of Items",
                      placeholder: "Select Items",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["2", "3", "4"],
                    },
                    // "label": {
                    //     "type": 'text',
                    //     "label": 'Label',
                    //     "placeholder": 'Enter Label',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 40,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "link_url": {
                    //     "type": 'text',
                    //     "label": 'Link',
                    //     "placeholder": 'Enter Link',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "role": {
                    //     "type": 'text',
                    //     "label": 'Role',
                    //     "placeholder": 'Enter Role',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "qualifications": {
                    //     "type": 'text',
                    //     "label": 'Qualifications',
                    //     "placeholder": 'Enter Qualifications',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "locations": {
                    //     "type": 'locationMultiSelect',
                    //     "label": 'Location(s)',
                    //     "inside": ['additionalProp1', 'availability', 'locations'],
                    //     "placeholder": 'Select Location',
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "gender": {
                    //     "type": 'radioObject',
                    //     "label": 'Gender',
                    //     "placeholder": 'Select Gender',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": [
                    //         {
                    //           "name": 'Male',
                    //         },
                    //         {
                    //           "name": 'Female',
                    //         }
                    //       ]
                    // },
                    // "group": {
                    //     "type": 'groupSelect',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "inside": ['additionalProp1', 'group'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "subgroup": {
                    //     "type": 'subgroupSelect',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "inside": ['additionalProp1', 'subgroup'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "group": {
                    //     "type": 'select',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "subgroup": {
                    //     "type": 'select',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "description": {
                    //     "type": 'ckeditor',
                    //     "label": 'Description',
                    //     "placeholder": 'Enter Description',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 2000,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { landingpage };
